import React from 'react';
import { Select } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@chakra-ui/react';
import { saveSetting } from '@/utils/settingsManager';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation('settings');
  const toast = useToast();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLanguage = e.target.value as 'en' | 'zh';
    i18n.changeLanguage(newLanguage);
    saveSetting('language', newLanguage);
    localStorage.setItem('i18nextLng', newLanguage); // 关键：同步给i18n
    toast({
      title: 'Language Changed',
      description: `Language changed to ${newLanguage === 'en' ? 'English' : '中文'}`,
      status: 'success',
      duration: 2000,
      isClosable: true,
    });
  };

  return (
    <Select 
      value={i18n.language || 'en'} 
      onChange={handleChange}
      size="md"
      variant="outline"
    >
      <option value="en">English</option>
      <option value="zh">中文</option>
    </Select>
  );
};

export default LanguageSwitcher; 